"use client";

import { FC, useCallback, useState } from "react";
import { useTranslations } from "next-intl";
import classNames from "classnames";

import { IconType } from "@types";
import { useGetCurrentUrl } from "utils";

import { Icon } from "components/atoms/Icon/Icon";

import s from "./Share.module.scss";

interface Props {
  title?: string;
  isBottom?: boolean;
}

export const Share: FC<Props> = ({ title, isBottom }) => {
  const t = useTranslations("common");
  const link = useGetCurrentUrl();
  const [showCopied, setShowCopied] = useState(false);

  const copyToClipboard = useCallback((text: string) => {
    const textarea = document.createElement("textarea");
    textarea.textContent = text;
    document.body.appendChild(textarea);

    const selection = document.getSelection();
    const range = document.createRange();
    range.selectNode(textarea);

    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);

      if (document.execCommand("copy")) {
        selection.removeAllRanges();
        document.body.removeChild(textarea);

        return true;
      }
    }

    return false;
  }, []);

  return (
    <div
      className={classNames(s.Share, {
        [s.IsBottom]: isBottom,
      })}
    >
      {title && <h3 className={s.Title}>{title}</h3>}
      <div className={s.Items}>
        <a
          href={`https://www.facebook.com/dialog/share?app_id=${process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}&display=popup&href=${link}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <Icon name={IconType.Facebook} size="xl" color="grey" />
        </a>
        <a
          href={`http://twitter.com/share?url=${link}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Twitter"
        >
          <Icon name={IconType.Twitter} size="xl" color="grey" />
        </a>
        <button
          type="button"
          onClick={() => {
            copyToClipboard(link);
            setShowCopied(true);
            setTimeout(() => setShowCopied(false), 5000);
          }}
          aria-label="Copy URL"
        >
          <Icon name={IconType.ShareLink} size="xl" color="grey" />
          {showCopied && <span className={s.Copied}>{t("link-copied")}</span>}
        </button>
      </div>
    </div>
  );
};
